import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-oltcard-res-spec-table',
  templateUrl: './oltcard-res-spec-table.component.html',
  styleUrls: ['./oltcard-res-spec-table.component.scss']
})
export class OLTCardResSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'totalPorts', 'occupancy', 'OLTCard-oltCard'];
    this.sort.sort({ id: 'OLTCard-oltCard', start: 'asc', disableClear: false});
    super.onInit();
  }

}
